import { UserOnlineListItem } from 'src/models/userOnlineList';

import { Callback } from 'src/util/query/models/Callback';

export class UserOnlineListCallback extends Callback<UserOnlineListItem[]> {
	public constructor(
		private readonly setInitialLoadingFinished: (state: boolean) => void,
		private readonly setUserOnlineList: (userOnlineList: Array<UserOnlineListItem>) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: UserOnlineListItem[]): void => {
		this.setUserOnlineList(successResponse);
		this.setInitialLoadingFinished(true);
	};
}
